module.exports = __webpack_public_path__ + "img/share_grey.99bc0f5f.svg";